export default "__VITE_ASSET__89484718__"